import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-time-menu-toggle',
  templateUrl: './time-menu-toggle.component.html',
  styleUrls: ['./time-menu-toggle.component.scss']
})
export class TimeMenuToggleComponent implements OnInit {

  @Input() activeSideMenu: any;
  @Input() gisMapComp: any
  is24Active;
  iscurrentActive;
  is10Active;
  moduleName: any;
  componentName: any;
  destroy: any = new Subject();
  isWeeklyActive: any;
  sourceSelected: any;
  isMonthlyActive: boolean;
  isSeasonalActive: boolean;
  isDeterministicActive: boolean
  isYTDActive: boolean;
  islast7DaysActive: boolean;


  constructor(private utils: UtilsService, private router: Router, private http: HttpClient, private route: ActivatedRoute) { }

  ngOnInit() {
    // Strip the query string first — e.g. a URL like '/weatherforecast/rainfall-forecast?forecastLength=-7D'
    // (as briefly used by the rainfallStations post-login redirect) would otherwise leave
    // componentName as 'rainfall-forecast?forecastLength=-7D', silently failing every
    // componentName === 'rainfall-forecast' check below and collapsing the time menu down to
    // just +24H/+7D. Mirrors GisDimsMapComponent.updateRouteParams()'s own split('?')[0] first.
    const urlWithoutQuery = this.router.url.split('?')[0];
    //   this.moduleName = this.router.url.split('/')[1];
    // this.componentName = this.router.url.split('/')[2];
    this.moduleName = urlWithoutQuery.split('/')[1];
    this.componentName = urlWithoutQuery.split('/')[2];
    console.log('moduleName', this.moduleName, 'componentName', this.componentName);
    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      // for (const param in params) {
      if (params.hasOwnProperty('forecastLength')) {
        this.sourceSelected = params['source']
        switch (params['forecastLength']) {
          case '-7D' : this.islast7DaysActive = true ; this.isYTDActive = false; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;
          case 'YTD': this.islast7DaysActive = false ; this.isYTDActive = true; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;
          case '24': this.islast7DaysActive = false ; this.isYTDActive = false; this.is24Active = true; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;
          case '10': this.islast7DaysActive = false ; this.isYTDActive = false; this.is10Active = true; this.is24Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;
          case 'weekly': this.islast7DaysActive = false ; this.isYTDActive = false; this.is10Active = false; this.is24Active = false; this.isWeeklyActive = true; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;
          case 'monthly': this.islast7DaysActive = false ;  this.isYTDActive = false; this.is10Active = false; this.is24Active = false; this.isWeeklyActive = false; this.isMonthlyActive = true; this.isSeasonalActive = false; this.isDeterministicActive = false; break;
          case 'seasonal': this.islast7DaysActive = false ; this.isYTDActive = false; this.is10Active = false; this.is24Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = true; this.isDeterministicActive = false; break;
          case 'deterministic': this.islast7DaysActive = false ; this.isYTDActive = false; this.is10Active = false; this.is24Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = true; break;
        }
      }
      // }
    })
  }

  routeChange(time) {
    // call utils service to call route changed
    // this.utils.setForecastLengthChanged(time);
    if (time === this.gisMapComp['params']['forecastLength']) {
      return;
    }
    if (this.gisMapComp.isStationActive && time !== '-7D') {
      this.gisMapComp.isStationActive = false;
      this.gisMapComp.actualView = 'HEATMAP';
      if (this.gisMapComp.injectedService && this.gisMapComp.injectedService.hideAllStationLayers) {
        this.gisMapComp.injectedService.hideAllStationLayers(this.gisMapComp);
      }
    }
    const urlWithoutQuery = this.router.url.split('?')[0];
    //  let moduleName: any = this.router.url.split('/')[1];
    // const componentName = this.router.url.split('/')[2];
    let moduleName: any = urlWithoutQuery.split('/')[1];
    const componentName = urlWithoutQuery.split('/')[2];
    // let stateId = (moduleName != 'thunderstorms' || moduleName != 'weatherforecast') ? this.router.url.split('/')[4] : this.router.url.split('/')[3];
    let stateId = (moduleName === 'thunderstorms' || moduleName === 'weatherforecast' || moduleName === 'heatwatch') ? this.router.url.split('/')[3] : this.router.url.split('/')[4];
    let options = { ...this.gisMapComp['params'] }
    const previousForecastLength = this.gisMapComp['params']['forecastLength'];
    options['forecastLength'] = time
    // if (componentName === 'rainfall-forecast' && time !== 'monthly' && time !== 'seasonal') {
    if (componentName === 'rainfall-forecast') {
      if (previousForecastLength === 'YTD' && (time === '-7D' || time === '24' || time === '10' || time ==='weekly' || time === 'deterministic' || time === 'monthly' || time === 'seasonal')) {
        options['source'] = 'ECMWF';
      }
      // Entering YTD from any other time menu: default to IMD-STATION (mirrors
      // RainfallForecastSidebarComponent.filterSourceOptions()'s own default) unless a
      // YTD-capable source is already active, so applyRainfallAdminView() below sees the real
      // resulting source and can decide whether a drilldown location is even valid to keep.
      if (time === 'YTD' && options['source'] !== 'IMD_GRID' && options['source'] !== 'IMD_STATION') {
        options['source'] = 'IMD_STATION';
      }
      this.resetForecastDisplayState(time, options);
      // Rainfall (Deterministic + Extended) only exists under +6W — leaving +6W via this
      // time toggle must fully restore normal Rainfall (source visible, report button visible,
      // normal heatmap/table/legend) for whichever length was just selected.
      if (time !== 'weekly') {
        options['rainfallMode'] = 'standard';
      }
      // 'weekly' (+6 W) supports Basin view just like 'monthly'/'seasonal' — only '24'/'10' are Admin-only.
      if (time !== 'monthly' && time !== 'seasonal' && time !== 'weekly') {
        options = this.applyRainfallAdminView(options);
      }
    }
    // if (moduleName != 'thunderstorms' || moduleName != 'weatherforecast') {
    //   this.router.navigate([moduleName, componentName, time, stateId]);
    // } else {
    //   this.gisMapComp['router'].navigate(['/' + this.gisMapComp.routeParams.dashboard + '/' + this.gisMapComp.componentType + '/akbm'], {
    //     relativeTo: this.gisMapComp['route'],
    //     queryParams: options,
    //     queryParamsHandling: 'merge'
    //   });
    // }
    if (moduleName === 'thunderstorms' || moduleName === 'weatherforecast' || moduleName === 'heatwatch' || moduleName == 'lightning' || moduleName == 'forecast') {
      // this.gisMapComp['router'].navigate(['/' + this.gisMapComp.routeParams.dashboard + '/' + this.gisMapComp.componentType + '/akbm'], {
      //   relativeTo: this.gisMapComp['route'],
      //   queryParams: options,
      //   queryParamsHandling: 'merge'
      // });
      this.utils.setSelectedParams(options)
    } else {
      // this.router.navigate([moduleName, componentName, time, stateId]);
    }
    switch (time) {

      case '-7D' : this.islast7DaysActive = true; this.isYTDActive = false; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;

      case 'YTD': this.islast7DaysActive = false; this.isYTDActive = true; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;

      case '24': this.islast7DaysActive = false; this.isYTDActive = false; this.is24Active = true; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;

      case '10': this.islast7DaysActive = false; this.isYTDActive = false; this.is24Active = false; this.is10Active = true; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;

      case 'weekly': this.islast7DaysActive = false; this.isYTDActive = false; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = true; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = false; break;

      case 'monthly': this.islast7DaysActive = false; this.isYTDActive = false; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = true; this.isSeasonalActive = false; this.isDeterministicActive = false; break;

      case 'seasonal': this.islast7DaysActive = false; this.isYTDActive = false; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = true;	this.isDeterministicActive = false; break;

      case 'deterministic': this.islast7DaysActive = false; this.isYTDActive = false; this.is24Active = false; this.is10Active = false; this.isWeeklyActive = false; this.isMonthlyActive = false; this.isSeasonalActive = false; this.isDeterministicActive = true; break;
    }
  }

  // Ensures the ECMWF ensemble-type and anomaly-percentage state is reinitialized on every
  // forecastLength transition, so state from a previously selected forecast length (e.g. +7M)
  // never leaks into another one (e.g. +6W) — see rainfall-forecast state-sync fix.
  private resetForecastDisplayState(forecastLength: string, options: any) {
    if (options['source'] !== 'ECMWF') {
      return;
    }
    const isExtendedRange = forecastLength === 'weekly' || forecastLength === 'monthly' || forecastLength === 'seasonal';
    if (!isExtendedRange) {
      return;
    }
    options['sourceType'] = 'anomaly';
    this.gisMapComp.isAnomalyPercentageActive = (forecastLength === 'monthly' || forecastLength === 'seasonal');
  }

  private applyRainfallAdminView(options: any) {
    options['view'] = 'Admin';
    // Preserve an existing Admin-view drill-down (State/District/Block) — only fall back
    // to the user's default root location when nothing has been selected yet, or when the
    // current selection is Basin-specific (BASINV2/SUBBASINV2 have no meaning in the Admin
    // hierarchy). Mirrors applyAdminViewParams() in rainfall-forecast-sidebar.component.ts.
    const basinLocTypes = ['BASINV2', 'SUBBASINV2'];
    // IMD-STATION supports no map/table drilldown at all, so a switch that lands on it must
    // never carry over a previously drilled State/District/Block location — always reset to
    // the user's Country/root level instead of keeping it.
    const noDrilldownSource = options['source'] === 'IMD_STATION';
    // if (options['locType'] && options['locType'] !== 'COUNTRY' && !basinLocTypes.includes(options['locType'])) {
    if (!noDrilldownSource && options['locType'] && options['locType'] !== 'COUNTRY' && !basinLocTypes.includes(options['locType'])) {
      return options;
    }

    return this.resetAdminRootLocation(options);
  }

  private resetAdminRootLocation(options: any) {
    const userLocationConfig = this.gisMapComp && this.gisMapComp.userLocationConfig;
    if (!userLocationConfig || !userLocationConfig.types || !userLocationConfig.locationInfo) {
      // options['view'] = 'Admin';
      return options;
    }

    const pType = userLocationConfig.types.pType;
    const location = userLocationConfig.locationInfo[pType.toLowerCase()];
    const currentLocations = location ? location.split('##') : [];

    // options['view'] = 'Admin';
    options['locType'] = pType;
    options['pType'] = pType;
    options['parentLoc'] = pType;
    options['cType'] = userLocationConfig.types.cType || (pType === 'COUNTRY' ? 'STATE' : 'DISTRICT');
    options['pUUID'] = currentLocations[1] || options['pUUID'];
    options['locName'] = currentLocations[0] || options['locName'];
    options['pEUUID'] = userLocationConfig.locationInfo.country ? userLocationConfig.locationInfo.country.split('##')[1] : options['pEUUID'];
    options['location'] = userLocationConfig.locationInfo.location || options['location'];

    return options;
  }

}
